import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable, Optional, SkipSelf} from '@angular/core';
import {ApiService, EnvironmentModel, FileUploadService, OrganisationResponse, SolutionEnvironmentModel} from '@cas-hub/acabim-common-client';
import {NGXLogger} from 'ngx-logger';
import {Observable, Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OrganisationSettingsService extends ApiService {

    protected controller = 'api/OrganisationSettings';

    constructor(protected readonly client: HttpClient,
                protected readonly environment: EnvironmentModel,
                private readonly fileUploaderService: FileUploadService,
                @SkipSelf() @Optional() protected solutionEnvironment?: SolutionEnvironmentModel,
                @Optional() protected readonly logger?: NGXLogger) {
        super(client, environment, solutionEnvironment, logger);
        this.serverHost = environment.authority;
    }

    public changeName(newName: string): Observable<any> {
        return this.client.put(this.url('name'), undefined, {
            headers: this.defaultHeaders,
            params: new HttpParams().set('name', newName),
            responseType: 'json'
        });
    }

    public changeLogo(file: File): Observable<OrganisationResponse> {
        const response = new Subject<OrganisationResponse>();
        this.fileUploaderService.updateFile('organisation/current/logo', file, undefined, (body => {
            if (body as OrganisationResponse) {
                response.next(body as OrganisationResponse);
            }
        })).subscribe(count => {
            this.logger?.debug('[OrganisationSettingsService] Uploading organisation logo image', count);
        }, error => response.error(error), () => response.complete());

        return response.pipe();
    }
}
